import { CalloutColor } from '../../../model';

export interface SimpleCalloutColorClasses {
  border: string;
  text: string;
  bg: string;
}

export interface SimpleCalloutColorOption {
  label: string;
  value: CalloutColor;
  colorClass: string;
}

export const simpleCalloutColorToLabel: Record<CalloutColor, string> = {
  [CalloutColor.Teal]: 'Teal',
  [CalloutColor.Indigo]: 'Indigo',
  [CalloutColor.Yellow]: 'Yellow',
  [CalloutColor.Red]: 'Red',
  [CalloutColor.Gray]: 'Gray',
  [CalloutColor.Green]: 'Green',
  [CalloutColor.Sky]: 'Sky',
  [CalloutColor.Pink]: 'Pink',
  [CalloutColor.Orange]: 'Orange',
};

export const simpleCalloutColorClassMap: Record<CalloutColor, SimpleCalloutColorClasses> = {
  [CalloutColor.Teal]: {
    border: 'border-teal-100 dark:border-teal-900',
    text: 'text-teal-500 dark:text-teal-400',
    bg: 'bg-teal-50 dark:bg-teal-950',
  },
  [CalloutColor.Indigo]: {
    border: 'border-indigo-100 dark:border-indigo-900',
    text: 'text-indigo-500 dark:text-indigo-400',
    bg: 'bg-indigo-50 dark:bg-indigo-950',
  },
  [CalloutColor.Yellow]: {
    border: 'border-amber-100 dark:border-amber-900',
    text: 'text-amber-500 dark:text-amber-400',
    bg: 'bg-amber-50 dark:bg-amber-950',
  },
  [CalloutColor.Red]: {
    border: 'border-red-100 dark:border-red-900',
    text: 'text-red-500 dark:text-red-400',
    bg: 'bg-red-50 dark:bg-red-950',
  },
  [CalloutColor.Gray]: {
    border: 'border-neutral-100 dark:border-neutral-900',
    text: 'text-neutral-500 dark:text-neutral-400',
    bg: 'bg-neutral-50 dark:bg-neutral-950',
  },
  [CalloutColor.Green]: {
    border: 'border-green-100 dark:border-green-900',
    text: 'text-green-500 dark:text-green-400',
    bg: 'bg-green-50 dark:bg-green-950',
  },
  [CalloutColor.Sky]: {
    border: 'border-sky-100 dark:border-sky-900',
    text: 'text-sky-500 dark:text-sky-400',
    bg: 'bg-sky-50 dark:bg-sky-950',
  },
  [CalloutColor.Pink]: {
    border: 'border-pink-100 dark:border-pink-900',
    text: 'text-pink-500 dark:text-pink-400',
    bg: 'bg-pink-50 dark:bg-pink-950',
  },
  [CalloutColor.Orange]: {
    border: 'border-orange-100 dark:border-orange-900',
    text: 'text-orange-500 dark:text-orange-400',
    bg: 'bg-orange-50 dark:bg-orange-950',
  },
};

/** Color swatches for the color picker - uses the -500 bg for the swatch dot */
export const simpleCalloutPickerColorMap: Record<CalloutColor, string> = {
  [CalloutColor.Teal]: 'bg-teal-500',
  [CalloutColor.Indigo]: 'bg-indigo-500',
  [CalloutColor.Yellow]: 'bg-amber-500',
  [CalloutColor.Red]: 'bg-red-500',
  [CalloutColor.Gray]: 'bg-neutral-500',
  [CalloutColor.Green]: 'bg-green-500',
  [CalloutColor.Sky]: 'bg-sky-500',
  [CalloutColor.Pink]: 'bg-pink-500',
  [CalloutColor.Orange]: 'bg-orange-500',
};
